<button class="ceres-button" data-testid="button" [ngClass]="classes" [disabled]="disabled" [type]="type">
    <ng-content></ng-content>
</button>
